// Zone.js configuration flags for Angular application.
// These flags must be set BEFORE zone.js is imported in polyfills.ts.
// See: https://angular.io/guide/zone#disabling-specific-apis-in-zonejs

// Do not patch high-frequency events to reduce Zone.js overhead.
// This is safe for most apps and рекомендовано официальной документацией.
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

